var map = {
	"./calculator/index.js": 70400,
	"./customer2/index.js": 60524,
	"./customers/index.js": 96716,
	"./index.js": 76485,
	"./pricing/index.js": 81093,
	"./products/index.js": 35491,
	"./solution/index.js": 56443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33996;